import AccountStoreMiddleware from "store/middlewares/AccountStoreMiddleware";
import CartStoreMiddleware from "store/middlewares/CartStoreMiddleware";
import ConfigStoreMiddleware from "store/middlewares/ConfigStoreMiddleware";

export default [
    AccountStoreMiddleware,
    CartStoreMiddleware,
    ConfigStoreMiddleware
]